import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Points } from '@styles';

export const Autosaving = () => {
  const translations = useTranslations();
  const { locale } = useSelector((state) => state.settings);
  return (
    <View locale={locale === 'ru' ? 'ru' : 'en'}>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.autosaving.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.autosaving.description')} />
      </Content>
    </View>
  );
};

const View = styled.div`
  position: relative;
  padding: 16px 16px 208px;
  color: ${Colors.main_black};
  border-radius: 15.13px;
  background: ${(p) => `image-set(
        url('/images/mainpage/autosaving-bg-mob-${p.locale}.webp') type('image/webp'),
        url('/images/mainpage/autosaving-bg-mob-${p.locale}.png') type('image/png')
      )
      16px 100% / 210px auto no-repeat,
    ${Colors.white}`};

  @media ${Points.tablet_landscape} {
    padding: 30px 33px 165px 30px;
    background: ${(p) => `image-set(
          url('/images/mainpage/autosaving-bg-tab-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/autosaving-bg-tab-${p.locale}.png') type('image/png')
        )
        30px 100% / 212px auto no-repeat,
      ${Colors.white}`};
  }

  @media ${Points.laptop_wide} {
    padding: 40px 40px 299px;
    border-radius: 20px;
    background: ${(p) => `image-set(
          url('/images/mainpage/autosaving-bg-lap-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/autosaving-bg-lap-${p.locale}.png') type('image/png')
        )
        40px 100% / 280px auto no-repeat,
      ${Colors.white}`};
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }

  @media ${Points.laptop_wide} {
    gap: 20px;
  }
`;
